import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18next';
import { profileApiSlice } from './ProfileApi';

const SLICE_NAME = 'profile';

const profileSlice = createSlice({
  name: SLICE_NAME,
  initialState: {},
  reducers: {},
  extraReducers(builder) {
    builder.addMatcher(profileApiSlice.endpoints.updateUserAddress.matchFulfilled, () => {      
        // TODO: notification
        // notify.success(i18n.t('profile:notifications.address-saved'));
    });
  },
});

export default profileSlice.reducer;
